import { useEffect, useState } from "react";
import SEO from "../components/SEO";
import FAQAccordion from "../components/sections/FAQAccordion";
import CTASection from "../components/sections/CTASection";
import { getFAQs } from "../lib/api";

export default function FAQs() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { getFAQs().then(setFaqs).catch(() => {}); }, []);

  return (
    <>
      <SEO title="Frequently Asked Questions | Pennsylvania Accident Aid" description="Honest answers to questions Pennsylvania accident victims ask us most." />
      <section className="pt-12 md:pt-20 pb-12 px-6 bg-bone">
        <div className="max-w-4xl mx-auto">
          <div className="overline mb-3">FAQs</div>
          <h1 className="text-4xl md:text-6xl font-display font-bold text-forest tracking-tight mb-5 text-balance">
            Your questions, answered honestly.
          </h1>
          <p className="text-lg text-charcoal-soft">
            We've gathered the most common questions Pennsylvania accident victims ask. If yours isn't here, just call.
          </p>
        </div>
      </section>
      <FAQAccordion items={faqs} title="All FAQs" />
      <CTASection />
    </>
  );
}
